import { postJsonRequest } from '@chilecompra/react-kit'
import { factoryService, getFileRequest, getJsonRequest, postFileRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_BUYER_URL } from '../config/settings/environment'

/**
 * Checks if the buyer is already registered.
 */
export const getBuyerAlreadyRegistered = factoryService(({ dni = '12345678-5' }) =>
  getJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/verificacion/institucion-existe/${dni}`)
)

/**
 * Checks if the buyer has pending requests.
 */
export const getBuyerPendingRequests = factoryService(({ dni = '12345678-5' }) =>
  getJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/verificacion/solicitud-estado/${dni}`)
)

/**
 * This function gets the options for required organisms.
 */
export const getOrganismTypes = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/tipo-organismos-obligatorios`, { retries: 2 })
)

/**
 * This function gets the directors.
 */
export const getDirectors = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/directores-subrogantes/director`, { retries: 2 })
)

/**
 * This function gets the surrogants.
 */
export const getSurrogants = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/directores-subrogantes/subrogantes`, { retries: 2 })
)

/**
 * Sends all the data of the registration forms to the backend.
 */
export const sendBuyerRegistrationData = factoryService(
  ({
    institucion,
    director,
    agreementType,
    mandatoryAgreement,
    adhesionAgreement,
    flow,
    guest,
    representativeAuthority,
    surrogantsList,
    token,
    legalRepresentation,
    emailVerify
  }) => {
    const body = {
      institucion,
      director,
      flujo: flow,
      personaAdministradora: guest,
      personaRepresentante: representativeAuthority,
      subrogantes: surrogantsList,
      codigoVerificacion: emailVerify,
      archivosPersoneria: legalRepresentation,
      orgObligatorio: agreementType,
      esObligatorio: mandatoryAgreement,
      convenioAdhesion: adhesionAgreement,
      token
    }
    return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/solicitud/crear-solicitud`, { body })
  }
)

/**
 * Gets the url to download the PDF after registration
 */
export const getBuyerRegistrationPDF = factoryService(({ numeroSolicitud }) => {
  return getFileRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/generar-pdf?numeroSolicitud=${numeroSolicitud}`)
})

/**
 * Sends an email with the registration data after registration
 */
export const sendBuyerRegistrationEmail = factoryService(({ email, requestCode }) => {
  const body = {
    email,
    numeroSolicitud: requestCode
  }
  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/correoEnvioSolicitud/enviar`, { body })
})

/**
 * Gets the the collaboration agreement pdf version
 */
export const getBuyerAgreementPDF = factoryService(({ convenio, institucion, firmante }) => {
  const body = {
    convenio,
    institucion,
    firmante
  }
  return postFileRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/convenio-adhesion-pdf`, {
    body
  })
})
